import { createReducer, on, Action } from '@ngrx/store';
import {
  ClearCountriesDataAction,
  GetCountriesFailed,
  GetCountriesSuccess,
  SetSelectedCountry,
} from './countries.actions';
import { CountriesState } from './countries.model';

export const initialState: CountriesState = {
  countries: [],
  selectedCountry: '',
};
export function CountriesReducer(
  state: CountriesState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetCountriesSuccess,
    (state, { countriesResponse }) =>
      ({
        ...state,
        ...countriesResponse,
      } as CountriesState)
  ),
  on(
    SetSelectedCountry,
    (state, { selectedCountry }) =>
      ({
        ...state,
        selectedCountry,
      } as CountriesState)
  ),
  on(
    GetCountriesFailed,
    (state, { payload }) =>
      ({
        ...state,
        countries: payload?.countries,
        error: payload?.error,
      } as CountriesState)
  ),
  on(ClearCountriesDataAction, (state) => initialState)
);
